import { SystemConfig } from "../../../hooks/useSystemConfig";
import { SettingsCenter } from "./getSettingsCenterData";
import { AddOnAppliesTo, AddOnsData, AddOnVisibility } from "./types";

const normalizeAddOns = (
  center: SettingsCenter,
  systemConfig: SystemConfig,
): AddOnsData => {
  const centerConfig = center.center_configs[0];

  const currencyCode =
    centerConfig?.default_currency_code || systemConfig.default_currency_code;

  const addOns = center.center_add_ons.map((addOn) => {
    const {
      id,
      name,
      price,
      type,
      applies_to,
      is_contacting_patient_required,
      marketing_text,
      is_per_study_pricing,
      visibility,
      allow_multiple_purchases,
    } = addOn;

    const appliesTo = (applies_to || "appointment") as AddOnAppliesTo;

    return {
      id,
      name,
      price,
      type,
      appliesTo,
      marketingText: marketing_text || "",
      isContactingPatientRequired: !!is_contacting_patient_required,
      isPerStudyPricing: !!is_per_study_pricing,
      visibility: visibility as AddOnVisibility,
      allowMultiplePurchases: !!allow_multiple_purchases,
    };
  });

  return { addOns, currencyCode };
};

export default normalizeAddOns;
